import * as contentful from 'contentful/dist/contentful.browser.min';

import CONFIG from 'config';

const SPACE_ID = CONFIG.contentful.spaceId;
const ACCESS_TOKEN = CONFIG.contentful.accessToken;
const HOST = 'cdn.contentful.com';

export const ContentfulClient = contentful.createClient({
  space: SPACE_ID,
  accessToken: ACCESS_TOKEN,
  host: HOST,
});

const queryMethod = ContentfulClient.getEntries;

ContentfulClient.getEntries = (query: any) => {
  return queryMethod.apply(this, [query]).catch(e => {
    console.log(e);

    return {
      total: 0,
      items: [],
    };
  });
};
